// https://github.com/angeloashmore/gatsby-source-prismic#Image-processing
import Img from "gatsby-image"

/** @jsx jsx */
import { jsx, Box } from 'theme-ui'

const Values = (props) => {
    const {
        title,
        intro_text,
        values,
        color,
        cover,
    } = props

    const getGridColumns = (values) => {
        if (values.length % 3 === 0) return 3;
        if (values.length % 2 === 0) return 2;
        return 1; // fallback if neither
    }

    return (
        <div sx={{ 
            mb: 4, borderRadius: 2, 
            bg: 'background',
            overflow: 'hidden',
            boxShadow: 0,
        }}>
            {cover && <Img fluid={cover} />}
            <div sx={{
                p: 4, 
            }}>
                <h2 sx={{mt: 0}}>{title ? title : "Nos valeurs"}</h2>
                <p>{intro_text}</p>
                <Box
                    sx={{
                        display: 'grid',
                        gap: 5,
                        gridTemplateColumns: [
                          '1fr', // mobile
                          'repeat(2, 1fr)', // tablet
                          `repeat(${getGridColumns(values)}, 1fr)` // desktop
                        ],
                    }}
                >
                    {values.map( (value, index) => {
                        const {
                            name,
                            description
                        } = value

                        return (
                            <div 
                                key={name}
                                sx={{
                                    position: 'relative',
                            }}>
                                <h3 sx={{
                                    mb: 2,
                                }}>
                                    {name}
                                </h3>
                                <span sx={{
                                    position: 'absolute',
                                    top: "-10px", left: "-20px",
                                    fontSize: 7, color: color, opacity: '.2', fontWeight: 'bold', lineHeight: 1,
                                }}>{index+1}</span>

                                <p sx={{
                                    fontSize: 1, mt: 0, mb: 1,
                                }}>
                                    {description}
                                </p>
                            </div>
                        )
                    })}
                </Box>
            </div>
        </div>
    )
}

export default Values